import { render, staticRenderFns } from "./index.vue?vue&type=template&id=110e9784&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110e9784')) {
      api.createRecord('110e9784', component.options)
    } else {
      api.reload('110e9784', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=110e9784&lang=pug", function () {
      api.rerender('110e9784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/contracts/permanentlyContractInfo/index.vue"
export default component.exports